<template>
  <q-btn
    v-if="isGranted('EDIT_CLIENT')"
    icon="fa fa-pencil-alt"
    label="Edit"
    title="Edit client"
    v-bind="$attrs"
    @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import isGranted from '@/auth/isGranted';
import { Client } from '@/type';
import openModal from '@/components/modal';
import EditClientModal from './EditClientModal.vue';

export default defineComponent({
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { client: _.cloneDeep(this.client) };
      openModal(EditClientModal, props);
    },
    isGranted,
  },
});
</script>
